/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigUnauthorizedResponse,
  BranchTcTransferConfigResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get TC transfer config based on branch type  for settling TCs
 */
export const branchTcTransferConfig = (branchType: 'DMB' | 'IND' | 'SP', signal?: AbortSignal) => {
  return customInstance<BranchTcTransferConfigResponseResponse>({
    url: `/BboBranchConfigService/v1/branch-tc-transfer-config/${branchType}`,
    method: 'get',
    signal,
  });
};

export const getBranchTcTransferConfigQueryKey = (branchType: 'DMB' | 'IND' | 'SP') => {
  return [`/BboBranchConfigService/v1/branch-tc-transfer-config/${branchType}`] as const;
};

export const getBranchTcTransferConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof branchTcTransferConfig>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  branchType: 'DMB' | 'IND' | 'SP',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof branchTcTransferConfig>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBranchTcTransferConfigQueryKey(branchType);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof branchTcTransferConfig>>> = ({ signal }) =>
    branchTcTransferConfig(branchType, signal);

  return { queryKey, queryFn, enabled: !!branchType, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof branchTcTransferConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BranchTcTransferConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof branchTcTransferConfig>>
>;
export type BranchTcTransferConfigQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Get TC transfer config based on branch type  for settling TCs
 */
export const useBranchTcTransferConfig = <
  TData = Awaited<ReturnType<typeof branchTcTransferConfig>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  branchType: 'DMB' | 'IND' | 'SP',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof branchTcTransferConfig>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBranchTcTransferConfigQueryOptions(branchType, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get TC transfer config based on branch type  for settling TCs
 */
export const branchTcTransferConfigV2 = (
  branchType: 'DMB' | 'IND' | 'SP',
  signal?: AbortSignal,
) => {
  return customInstance<BranchTcTransferConfigResponseResponse>({
    url: `/BboBranchConfigService/v2/branch-tc-transfer-config/${branchType}`,
    method: 'get',
    signal,
  });
};

export const getBranchTcTransferConfigV2QueryKey = (branchType: 'DMB' | 'IND' | 'SP') => {
  return [`/BboBranchConfigService/v2/branch-tc-transfer-config/${branchType}`] as const;
};

export const getBranchTcTransferConfigV2QueryOptions = <
  TData = Awaited<ReturnType<typeof branchTcTransferConfigV2>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  branchType: 'DMB' | 'IND' | 'SP',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof branchTcTransferConfigV2>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBranchTcTransferConfigV2QueryKey(branchType);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof branchTcTransferConfigV2>>> = ({
    signal,
  }) => branchTcTransferConfigV2(branchType, signal);

  return { queryKey, queryFn, enabled: !!branchType, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof branchTcTransferConfigV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BranchTcTransferConfigV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof branchTcTransferConfigV2>>
>;
export type BranchTcTransferConfigV2QueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Get TC transfer config based on branch type  for settling TCs
 */
export const useBranchTcTransferConfigV2 = <
  TData = Awaited<ReturnType<typeof branchTcTransferConfigV2>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  branchType: 'DMB' | 'IND' | 'SP',
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof branchTcTransferConfigV2>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBranchTcTransferConfigV2QueryOptions(branchType, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
